import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  FormControlLabel,
  Grid,
  Paper
} from '@mui/material';
import {showSuccessToast,showErrorToast,} from '../../../common/components/Helper/Utils';
import {createShopifySettings,updateShopifySettings,getShopifySettings,} from './actions/administration';
import { Switch } from '@material-ui/core';
import { SpinnerRoundFilled } from "spinners-react";
import CircularProgress from "@material-ui/core/CircularProgress";

const ShopifySettings = () => {
  const [isEditable, setIsEditable] = useState(false);
  const [settingsData, setSettingsData] = useState(false);
  const [settingId, setSettingId] = useState(null);
   const [inventoryTitle, setInventoryTitle] = useState(true);
  const [reference, setReference] = useState(true);
  const [modelName, setModelName] = useState(true);
  const [brand, setBrand] = useState(true);
  const [condition, setCondition] = useState(true);
  const [box, setBox] = useState(true);
  const [warranty, setWarranty] = useState(true);
  const [warrantyDate, setWarrantyDate] = useState(true);
  const [caseMaterial, setCaseMaterial] = useState(true);
  const [strapMaterial, setStrapMaterial] = useState(true);
  const [watchopsPullModified, setWatchopsPullModified] = useState(true);
  const [inventoryId, setInventoryId] = useState(true);
  const [updateQuantityAvailable, setUpdateQuantityAvailable] = useState(true);
  const [importCustomerShopify, setImportCustomerShopify] = useState(true);
  const [importInvoiceShopify, setImportInvoiceShopify] = useState(true);
  const [isDescriptionTable, setIsDescriptionTable] = useState(true);
  const [isDraftStatus, setIsDraftStatus] = useState(true);
  const [isOverrideContactInformation, setIsOverrideContactInformation] = useState(true);
  const [isInvoiceFullyPaid, setIsInvoiceFullyPaid] = useState(true);
  const [loader, setloader] = useState(true);

  const getShopifySettingsData = () => {
    setloader(true);
    getShopifySettings((err, res) => {
      if (res?.status === 1 && res.data) {
        const data = res.data;   
        setSettingId(data.id ?? null);
        setInventoryTitle(data.inventory_title ?? true);
        setReference(data.reference ?? true);
        setModelName(data.model_name ?? true);
        setBrand(data.brand ?? true);
        setCondition(data.condition ?? true);
        setBox(data.box ?? true);
        setWarranty(data.warranty ?? true);
        setWarrantyDate(data.warrantydate ?? true);
        setCaseMaterial(data.casematerial ?? true);
        setStrapMaterial(data.strap_material ?? true);
        setWatchopsPullModified(data.watchops_pull_modified ?? true);
        setInventoryId(data.inventoryid ?? true);
        setUpdateQuantityAvailable(data.update_quantity_available ?? true);
        setImportCustomerShopify(data.import_customer_shopify ?? true);
        setImportInvoiceShopify(data.import_invoice_shopify ?? true);
        setIsDescriptionTable(data.is_description_table ?? true);
        setIsDraftStatus(data.isdraftstatus ?? true);
        setIsOverrideContactInformation(data.is_override_contact_information ?? true);
        setIsInvoiceFullyPaid(data.is_invoice_fully_paid ?? true);
      }
      setloader(false);
    });
  };

  const handleSaveSettings = () => {
    const accountid = window.sessionStorage.getItem('accountId');
    const payload = {
      accountid,
      inventory_title: inventoryTitle,
      reference: reference,
      model_name: modelName,
      brand: brand,
      condition: condition,
      box: box,
      warranty: warranty,
      warrantydate: warrantyDate,
      casematerial: caseMaterial,
      strap_material: strapMaterial,
      watchops_pull_modified: watchopsPullModified,
      inventoryid: inventoryId,
      update_quantity_available: updateQuantityAvailable,
      import_customer_shopify: importCustomerShopify,
      import_invoice_shopify: importInvoiceShopify,
      is_description_table: isDescriptionTable,
      isdraftstatus: isDraftStatus,
      is_override_contact_information: isOverrideContactInformation,
      is_invoice_fully_paid: isInvoiceFullyPaid
    };
      setSettingsData(true);

    if (settingId) {
      payload.id = settingId;
      updateShopifySettings(payload, (err, response) => {
        if (response?.status === 1) {
          showSuccessToast('Settings updated successfully');
          setIsEditable(false);
          getShopifySettingsData();
        } else {
          showErrorToast('Failed to update settings');
        }
        setSettingsData(false);
      });
    } else {
      createShopifySettings(payload, (err, response) => {
        if (response?.status === 1) {
          showSuccessToast('Settings created successfully');
          setSettingId(response.id ?? response.data?.id ?? null);
          setIsEditable(false);
          getShopifySettingsData();
        } else {
          showErrorToast('Failed to create settings');
        }
      });
    }
  };

  useEffect(() => {
    getShopifySettingsData();
  }, []);

  const renderSwitch = (label, value, setter) => (
    <Grid item xs={12} sm={6} md={6}>
      <FormControlLabel
        control={
          <Switch
            checked={!!value}
            onChange={() => isEditable && setter(!value)}
            disabled={!isEditable}
          />
        }
        label={label}
        sx={{ width: '100%', pl: 1 }}
      />
    </Grid>
  );
  if (loader) {
          return (
              <div className="d-spinner">
                  <SpinnerRoundFilled
                      size={51}
                      thickness={125}
                      speed={80}
                      color="rgba(57, 107, 172, 1)"
                      className="spp"
                      enabled={loader}
                  />
              </div>
              );
  }
  return (
    <Paper elevation={2} sx={{ p: 4, borderRadius: 2 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h6" className="primary-text uppercase">Product Settings</Typography>
        <Button
          variant="contained"
          className="primary-bg color-white"
          disabled={settingsData}
          onClick={() => {
            if (isEditable) {
              handleSaveSettings();
            } else {
              setIsEditable(true);
            }
          }}
          endIcon={
            settingsData ? (
              <CircularProgress style={{ width: 20, height: 20, color: '#fff' }} />
            ) : null
          }
        >
          {isEditable ? (settingsData ? "Saving..." : "Save") : "Edit"}
        </Button>
      </Box>

      <Grid container spacing={1}>
        {renderSwitch(isDescriptionTable ? "Show Description as a Table" : "Show Description as a Paragraph", isDescriptionTable, setIsDescriptionTable)}
        {renderSwitch(isDraftStatus ? "Create Product in Draft Status" : "Create Product in Active Status" , isDraftStatus, setIsDraftStatus)}
      </Grid>

      <Typography variant="h6" className="primary-text uppercase" mt={4} mb={1}>Product Description</Typography>
      <Grid container spacing={1}>
        {/* {renderSwitch("label",value,setter)} */}
        {renderSwitch("Inventory Title", inventoryTitle, setInventoryTitle)}
        {renderSwitch("Ref #", reference, setReference)}
        {renderSwitch("Model Name", modelName, setModelName)}
        {renderSwitch("Brand", brand, setBrand)}
        {renderSwitch("Condition", condition, setCondition)}
        {renderSwitch("Box", box, setBox)}
        {renderSwitch("Papers/Warranty", warranty, setWarranty)}
        {renderSwitch("Warranty Date", warrantyDate, setWarrantyDate)}
        {renderSwitch("Case Material", caseMaterial, setCaseMaterial)}
        {renderSwitch("Strap Material", strapMaterial, setStrapMaterial)}
        {renderSwitch("If Modified field in WatchOPS is YES, then pull that information", watchopsPullModified, setWatchopsPullModified)}
        {renderSwitch("Inventory ID", inventoryId, setInventoryId)}
        {renderSwitch("Update Quantity Available 1", updateQuantityAvailable, setUpdateQuantityAvailable)}
      </Grid>

      <Typography variant="h6" className="primary-text uppercase" mt={4} mb={1}>
        Invoice Configuration
      </Typography>

      <Grid container spacing={1}>
        {renderSwitch("Import Customer Information from Shopify", importCustomerShopify, setImportCustomerShopify)}
        {renderSwitch("Import Invoice Information from Shopify", importInvoiceShopify, setImportInvoiceShopify)}
        {renderSwitch("Override Contact Information", isOverrideContactInformation, setIsOverrideContactInformation)}
        {renderSwitch(isInvoiceFullyPaid ? "Mark invoice as Fully Paid" : "Mark invoice as Not Paid", isInvoiceFullyPaid, setIsInvoiceFullyPaid)}
      </Grid>
    </Paper>
  );
};

export default ShopifySettings;